// Catálogo de productos BH La Marca del Panadero
// Cada producto puede tener: id, nombre, modelo, descripcion, specs, imagen, ficha (PDF)

export const categorias = [
  {
    id: 'amasadoras-semirapidas',
    nombre: 'Amasadoras Semirápidas',
    descripcion: 'Amasadoras de brazo semirápido para producción continua.',
    productos: [
      {
        id: 'BA30',
        modelo: 'BA30',
        nombre: 'Amasadora Semirápida BA30',
        tipo: 'Amasadora semirrápida industrial',
        descripcion: 'La Amasadora BA30 de BH está diseñada para panaderías, fábricas y emprendimientos gastronómicos que buscan un equipo robusto, confiable y de fácil operación. Su construcción sólida en acero y su sistema de amasado semirrápido garantizan una mezcla homogénea en tiempos eficientes, ideal para trabajos diarios continuos.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '25 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1 HP (0,73 kW)' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 10 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '100 kg' },
        ],
        imagen: '/assets/productos/amasadoras-semirapidas/BA30.png',
        ficha: '/productos/ficha/BA30',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BA50',
        modelo: 'BA50',
        nombre: 'Amasadora Semirápida BA50',
        tipo: 'Amasadora semirrápida industrial',
        descripcion: 'La Amasadora BA50 de BH está pensada para panaderías y fábricas que requieren mayor volumen de producción sin resignar calidad. Con una capacidad de 50 kg de harina seca, su estructura robusta en acero y su sistema de amasado semirrápido garantizan una mezcla uniforme y eficiente en cada ciclo, ideal para operaciones diarias de alta demanda.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '50 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '3 HP (2,2 kW)' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 13 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '250 kg' },
        ],
        imagen: '/assets/productos/amasadoras-semirapidas/BA50.png',
        ficha: '/productos/ficha/BA50',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BA70',
        modelo: 'BA70',
        nombre: 'Amasadora Semirápida BA70',
        tipo: 'Amasadora semirrápida industrial',
        descripcion: 'La Amasadora BA70 de BH es la opción ideal para establecimientos que demandan una producción sostenida y de gran volumen. Con capacidad para 75 kg de harina seca, combina robustez estructural con un sistema de amasado semirrápido que asegura una mezcla homogénea en cada ciclo, reduciendo tiempos y maximizando el rendimiento diario.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '75 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '4 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 14 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '290 kg' },
        ],
        imagen: '/assets/productos/amasadoras-semirapidas/BA70.png',
        ficha: '/productos/ficha/BA70',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BA100',
        modelo: 'BA100',
        nombre: 'Amasadora Semirápida BA100',
        tipo: 'Amasadora semirrápida industrial',
        descripcion: 'La Amasadora BA100 de BH está diseñada para plantas de producción de alto rendimiento que no admiten paradas. Con una capacidad de 100 kg de harina seca y motor de 5,5 HP, ofrece potencia y consistencia en cada amasado, garantizando resultados uniformes ciclo tras ciclo en las operaciones más exigentes.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '100 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '5,5 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 15 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '380 kg' },
        ],
        imagen: '/assets/productos/amasadoras-semirapidas/BA100.png',
        ficha: '/productos/ficha/BA100',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BA150',
        modelo: 'BA150',
        nombre: 'Amasadora Semirápida BA150',
        tipo: 'Amasadora semirrápida industrial',
        descripcion: 'La Amasadora BA150 de BH es la solución de mayor capacidad de la línea semirrápida, pensada para grandes plantas industriales con producción continua e ininterrumpida. Sus 150 kg de capacidad y motor de 7,5 HP la convierten en una herramienta de alto desempeño que combina potencia, durabilidad y eficiencia en cada ciclo.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '150 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '7,5 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 15 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '450 kg' },
        ],
        imagen: '/assets/productos/amasadoras-semirapidas/BA150.png',
        ficha: '/productos/ficha/BA150',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'amasadoras-rapidas',
    nombre: 'Amasadoras Rápidas',
    descripcion: 'Amasadoras de alta velocidad para mayor rendimiento productivo.',
    productos: [
      {
        id: 'BA30R',
        modelo: 'BA30R',
        nombre: 'Amasadora Rápida BA30R',
        descripcion: '',
        specs: [],
        imagen: '/assets/productos/amasadoras-rapidas/BA30R.png',
        ficha: null,
      },
      {
        id: 'BA50R',
        modelo: 'BA50R',
        nombre: 'Amasadora Rápida BA50R',
        tipo: 'Amasadora rápida industrial',
        descripcion: 'La Amasadora Rápida BA50R de BH está diseñada para plantas de producción que exigen velocidad y potencia sin comprometer la calidad del amasado. Con motor de espiral de 7,5 HP y motor de olla de 1 HP, su sistema de doble velocidad permite adaptarse a distintos tipos de masa, garantizando una mezcla homogénea y eficiente en cada ciclo.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '50 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '7,5 HP (espiral) / 1 HP (olla)' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '2 velocidades' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 10 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '500 kg' },
        ],
        imagen: '/assets/productos/amasadoras-rapidas/BA50-R.png',
        ficha: '/productos/ficha/BA50R',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BA150R',
        modelo: 'BA150R',
        nombre: 'Amasadora Rápida BA150R',
        descripcion: '',
        specs: [],
        imagen: '/assets/productos/amasadoras-rapidas/BA150R.png',
        ficha: null,
      },
    ],
  },
  {
    id: 'amasadora-volcable',
    nombre: 'Amasadora Volcable',
    descripcion: 'Amasadora con sistema de volcado para facilitar la descarga.',
    productos: [
      {
        id: 'BA50-V',
        modelo: 'BA50-V',
        nombre: 'Amasadora Volcable BA50-V',
        tipo: 'Amasadora volcable para masas granuladas',
        descripcion: 'La Amasadora Volcable BA50-V de BH es la solución ideal para el procesamiento de masas granuladas que requieren una descarga eficiente y sin esfuerzo. Su sistema volcable facilita el vaciado completo de la batea, reduciendo tiempos operativos y mejorando la ergonomía del trabajo. Construida en acero SAE 1010 con batea de acero inoxidable 304, combina durabilidad y fácil higienización para un uso intensivo diario.',
        specs: [
          { icono: '⚖️', label: 'Capacidad máxima', valor: '50 kg de harina seca' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '3 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🔄', label: 'Velocidades', valor: '1 velocidad' },
          { icono: '⏱️', label: 'Tiempo de amasado', valor: 'Aproximadamente 10 minutos por ciclo' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 — Batea en acero inoxidable 304' },
          { icono: '🏋️', label: 'Peso', valor: '150 kg' },
        ],
        imagen: '/assets/productos/amasadora-volcable/BA50-Volcable.png',
        ficha: '/productos/ficha/BA50-V',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'sobadoras',
    nombre: 'Sobadoras',
    descripcion: 'Sobadoras industriales para una masa perfectamente trabajada.',
    productos: [
      {
        id: 'BH500',
        modelo: 'BH500',
        nombre: 'Sobadora Pastelera BH500',
        tipo: 'Sobadora pastelera industrial',
        descripcion: 'La Sobadora Pastelera BH500 de BH es una máquina compacta y potente diseñada para sobar cantidades medianas de masa, ideal para pastelerías, confiterías y panaderías que buscan calidad. Su construcción robusta con estructura de acero inoxidable y rodillos de alta precisión ofrece una operación confiable. Su motor de 1,5 HP y rodillos de diámetro específico garantizan un estirado uniforme y eficiente de la masa, optimizando la producción de hojaldres, masas de tarta y laminados diversos.',
        specs: [
          { icono: '🏗️', label: 'Estructura', valor: 'Acero inoxidable, de alta resistencia y fácil limpieza' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1,5 HP (1,1 kW), trifásico / monofásico' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica / monofásica)' },
          { icono: '⭕', label: 'Rodillos laminadores', valor: 'Ø 115 mm' },
          { icono: '⛓️', label: 'Sistema de transmisión', valor: 'A cadena y engranajes de acero' },
          { icono: '🔩', label: 'Montaje', valor: 'Rodillos sobre bujes de bronce autolubricados' },
          { icono: '🏋️', label: 'Peso', valor: '110 kg' },
        ],
        imagen: '/assets/productos/sobadoras/BH500.png',
        ficha: '/productos/ficha/BH500',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BH600',
        modelo: 'BH600',
        nombre: 'Sobadora Pesada BH600',
        tipo: 'Sobadora pesada industrial',
        descripcion: 'La Sobadora BH600 de BH es una máquina robusta para sobar grandes cantidades de masa, esencial para panaderías y fábricas. Fabricada íntegramente en acero inoxidable, ofrece una operación confiable y precisa. Su potente motor de 4 HP y rodillos de gran diámetro garantizan un estirado uniforme y eficiente de la masa, ideal para producciones exigentes y uso continuo.',
        specs: [
          { icono: '🏗️', label: 'Estructura', valor: 'Acero inoxidable, de alta resistencia y fácil limpieza' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '4 HP (3 kW), trifásico' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '⭕', label: 'Rodillos laminadores', valor: 'Ø 160 mm' },
          { icono: '⛓️', label: 'Sistema de transmisión', valor: 'A cadena y engranajes de acero' },
          { icono: '🔩', label: 'Montaje', valor: 'Rodillos sobre bujes de bronce autolubricados' },
          { icono: '🏋️', label: 'Peso', valor: '400 kg' },
        ],
        imagen: '/assets/productos/sobadoras/BH600.png',
        ficha: '/productos/ficha/BH600',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'laminadora-empanadas',
    nombre: 'Laminadora de Empanadas',
    descripcion: 'Laminadora para tapas de empanadas con espesor preciso y uniforme.',
    productos: [
      {
        id: 'LAM600',
        modelo: 'LAM600',
        nombre: 'Laminadora de Empanadas LAM600',
        tipo: 'Laminadora industrial para tapas de empanadas',
        descripcion: 'La Laminadora LAM600 de BH está diseñada para la producción eficiente de tapas de empanadas con espesor uniforme y preciso. Fabricada en acero inoxidable, garantiza higiene y durabilidad en el uso intensivo diario. Su sistema de rodillos de gran diámetro y transmisión a cadena aseguran un laminado homogéneo, ideal para panaderías, confiterías y fábricas de empanadas.',
        specs: [
          { icono: '🏗️', label: 'Estructura', valor: 'Acero inoxidable, de alta resistencia y fácil limpieza' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '4 HP (3 kW), trifásico' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '⭕', label: 'Rodillos laminadores', valor: 'Ø 160 mm' },
          { icono: '⛓️', label: 'Sistema de transmisión', valor: 'A cadena y engranajes de acero' },
          { icono: '🔩', label: 'Montaje', valor: 'Rodillos sobre bujes de bronce autolubricados' },
          { icono: '🏋️', label: 'Peso', valor: '400 kg' },
        ],
        imagenes: [
          '/assets/productos/laminadora-empanadas/LAM600.png',
          '/assets/productos/laminadora-empanadas/LAM600-2.png',
        ],
        imagen: '/assets/productos/laminadora-empanadas/LAM600.png',
        ficha: '/productos/ficha/LAM600',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'batidoras-planetarias',
    nombre: 'Batidoras Planetarias',
    descripcion: 'Batidoras de movimiento planetario para pastelería y confitería.',
    productos: [
      {
        id: 'BM20',
        modelo: 'BM20',
        nombre: 'Batidora Planetaria BM20',
        tipo: 'Batidora Planetaria Industrial',
        descripcion: 'La Batidora Planetaria BM20 de BH está diseñada para pastelerías, heladerías y establecimientos gastronómicos que requieren versatilidad para batir, mezclar y amasar. Su robusta construcción y sistema planetario aseguran un batido eficiente de crema, merengue, masas livianas y pesadas, en tiempos controlados para una producción constante.',
        specs: [
          { icono: '🥣', label: 'Capacidad de la cuba', valor: '20 Litros (Acero Inoxidable)' },
          { icono: '🔄', label: 'Velocidades', valor: '5 velocidades (Control mecánico lateral)' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '0,5 HP (0,37 kW)' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🧰', label: 'Accesorios incluidos', valor: '3 — Gancho amasador, Paleta batidora de manteca, Batidor de alambre' },
          { icono: '⛓️', label: 'Sistema', valor: 'Transmisión por correas y piñón planetario' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '85 kg' },
        ],
        imagen: '/assets/productos/batidoras-planetarias/BM20.png',
        ficha: '/productos/ficha/BM20',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BM36',
        modelo: 'BM36',
        nombre: 'Batidora Planetaria BM36',
        tipo: 'Batidora Planetaria Industrial',
        descripcion: 'La Batidora Planetaria BM36 de BH es una amasadora industrial de alta capacidad, diseñada para panaderías y confiterías de mediana y gran escala. Con su sistema planetario de precisión y su gran volumen de 36 litros, es ideal para la producción continua de masas densas y batidos voluminosos, garantizando consistencia en lotes de producción diarios.',
        specs: [
          { icono: '🥣', label: 'Capacidad de la cuba', valor: '36 Litros (Acero Inoxidable)' },
          { icono: '🔄', label: 'Velocidades', valor: '5 velocidades (Control mecánico lateral)' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🧰', label: 'Accesorios incluidos', valor: '3 — Gancho amasador, Paleta, Batidor de alambre' },
          { icono: '⛓️', label: 'Sistema', valor: 'Transmisión por correas y piñón planetario' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '105 kg' },
        ],
        imagenes: [
          '/assets/productos/batidoras-planetarias/BM36.png',
          '/assets/productos/batidoras-planetarias/BM36-1.png',
        ],
        imagen: '/assets/productos/batidoras-planetarias/BM36.png',
        ficha: '/productos/ficha/BM36',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'BM50',
        modelo: 'BM50',
        nombre: 'Batidora Planetaria BM50',
        tipo: 'Batidora Planetaria Industrial',
        descripcion: 'La Batidora Planetaria BM50 de BH es una amasadora industrial de alta capacidad, diseñada para panaderías y confiterías de gran escala. Con su sistema planetario de alta precisión y su gran volumen de 50 litros, es ideal para la producción continua de masas densas y batidos voluminosos, garantizando consistencia en lotes de producción diarios.',
        specs: [
          { icono: '🥣', label: 'Capacidad de la cuba', valor: '50 Litros (Acero Inoxidable)' },
          { icono: '🔄', label: 'Velocidades', valor: '5 velocidades (Control mecánico lateral)' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1,5 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🧰', label: 'Accesorios incluidos', valor: '3 — Gancho amasador, Paleta batidora de manteca, Batidor de alambre' },
          { icono: '⛓️', label: 'Sistema', valor: 'Transmisión por correas y piñón planetario' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010 pintada con pintura epoxi' },
          { icono: '🏋️', label: 'Peso', valor: '125 kg' },
        ],
        imagen: '/assets/productos/batidoras-planetarias/BM50.png',
        ficha: '/productos/ficha/BM50',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'equipos-compactos',
    nombre: 'Equipos Compactos',
    descripcion: 'Línea compacta todo-en-uno para espacios reducidos.',
    productos: [
      {
        id: 'CAT450',
        modelo: 'CAT450',
        nombre: 'Equipo Compacto CAT450',
        tipo: 'Línea compacta de panificación industrial',
        descripcion: 'El Equipo Compacto CAT450 de BH integra en una sola máquina las funciones necesarias para la producción eficiente de pan de molde. Con trincha de 45 cm y capacidad para 5 moldes simultáneos, es la solución ideal para panaderías y fábricas que buscan optimizar espacio sin resignar volumen de producción.',
        specs: [
          { icono: '📏', label: 'Ancho de trincha', valor: '45 cm' },
          { icono: '⚖️', label: 'Capacidad de producción', valor: '400 kg por hora' },
          { icono: '🍞', label: 'Moldes de pan', valor: '5 moldes simultáneos' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1,5 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010' },
          { icono: '🏋️', label: 'Peso', valor: '300 kg' },
        ],
        imagen: '/assets/productos/equipos-compactos/CAT450.png',
        ficha: '/productos/ficha/CAT450',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'CAT700',
        modelo: 'CAT700',
        nombre: 'Equipo Compacto CAT700',
        tipo: 'Línea compacta de panificación industrial',
        descripcion: 'El Equipo Compacto CAT700 de BH es la versión de mayor capacidad de la línea compacta, con trincha de 70 cm para una producción más amplia de pan de molde. Mantiene la misma robustez y eficiencia del CAT450, ideal para establecimientos que requieren mayor volumen en el mismo espacio.',
        specs: [
          { icono: '📏', label: 'Ancho de trincha', valor: '70 cm' },
          { icono: '⚖️', label: 'Capacidad de producción', valor: '400 kg por hora' },
          { icono: '🍞', label: 'Moldes de pan', valor: '5 moldes simultáneos' },
          { icono: '⚙️', label: 'Potencia del motor', valor: '1,5 HP' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (trifásica)' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Estructura en acero SAE 1010' },
          { icono: '🏋️', label: 'Peso', valor: '300 kg' },
        ],
        imagen: '/assets/productos/equipos-compactos/CAT700.png',
        ficha: '/productos/ficha/CAT700',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'hornos-rotativos',
    nombre: 'Hornos Rotativos',
    descripcion: 'Hornos rotativos de alta capacidad para cocción uniforme.',
    productos: [
      {
        id: 'RBH25',
        modelo: 'RBH25',
        nombre: 'Horno Rotativo RBH25',
        tipo: 'Horno Rotativo Industrial',
        descripcion: 'El Horno Rotativo RBH25 de BH es la opción compacta de la línea rotativa, ideal para panaderías y confiterías que buscan cocción uniforme con menor volumen de producción. Su sistema rotativo garantiza una distribución homogénea del calor en cada ciclo. Construido en acero inoxidable 430 y compatible con gas o electricidad, está diseñado para el uso intensivo diario.',
        specs: [
          { icono: '🍞', label: 'Capacidad', valor: '8 bandejas 45 × 70 cm' },
          { icono: '🔥', label: 'Potencia calórica', valor: '20.000 Kcal' },
          { icono: '⚙️', label: 'Potencia eléctrica', valor: '1 kW' },

          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🔥', label: 'Combustible', valor: 'Gas / Eléctrico' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Acero inoxidable 430' },
          { icono: '🏋️', label: 'Peso', valor: '300 kg' },
        ],
        imagen: '/assets/productos/hornos-rotativos/RBH25.png',
        ficha: '/productos/ficha/RBH25',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'RBH50',
        modelo: 'RBH50',
        nombre: 'Horno Rotativo RBH50',
        tipo: 'Horno Rotativo Industrial',
        descripcion: 'El Horno Rotativo RBH50 de BH es la opción ideal para panaderías medianas que buscan cocción uniforme y eficiente. Su sistema rotativo distribuye el calor de manera homogénea en cada ciclo, garantizando resultados consistentes en pan, medialunas y productos de panadería. Construido en acero inoxidable 430 y compatible con gas o electricidad, está diseñado para el uso intensivo diario.',
        specs: [
          { icono: '⚖️', label: 'Capacidad de producción', valor: '50 kg por hora' },
          { icono: '🛒', label: 'Dimensiones del carro', valor: '45 × 70 cm / 40 × 60 cm' },
          { icono: '🔥', label: 'Potencia calórica', valor: '40.000 Kcal' },
          { icono: '⚙️', label: 'Potencia eléctrica', valor: '2,2 kW' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🔥', label: 'Combustible', valor: 'Gas / Eléctrico' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Acero inoxidable 430' },
          { icono: '🏋️', label: 'Peso', valor: '500 kg' },
        ],
        imagenes: [
          '/assets/productos/hornos-rotativos/RBH50.png',
          '/assets/productos/hornos-rotativos/RBH50-1.png',
        ],
        imagen: '/assets/productos/hornos-rotativos/RBH50.png',
        ficha: '/productos/ficha/RBH50',
        telefono: '+54 9 11 4088-2236',
      },
      {
        id: 'RBH130',
        modelo: 'RBH130',
        nombre: 'Horno Rotativo RBH130',
        tipo: 'Horno Rotativo Industrial',
        descripcion: 'El Horno Rotativo RBH130 de BH es la solución ideal para panaderías y fábricas que buscan máxima producción con cocción uniforme. Su sistema rotativo garantiza una distribución homogénea del calor en cada ciclo, logrando resultados consistentes en pan, medialunas y todo tipo de productos de panadería. Construido en acero inoxidable 430 y compatible con gas o electricidad, está diseñado para el uso intensivo diario.',
        specs: [
          { icono: '⚖️', label: 'Capacidad de producción', valor: '130 kg por hora' },
          { icono: '🛒', label: 'Dimensiones del carro', valor: '70 × 90 cm' },
          { icono: '🔥', label: 'Potencia calórica', valor: '80.000 Kcal' },
          { icono: '⚙️', label: 'Potencia eléctrica', valor: '2,2 kW' },
          { icono: '⚡', label: 'Tensión de alimentación', valor: '220 V / 380 V (Trifásica)' },
          { icono: '🔥', label: 'Combustible', valor: 'Gas / Eléctrico' },
          { icono: '🏗️', label: 'Material de construcción', valor: 'Acero inoxidable 430' },
          { icono: '🏋️', label: 'Peso', valor: '500 kg' },
        ],
        imagenes: [
          '/assets/productos/hornos-rotativos/RBH130.png',
          '/assets/productos/hornos-rotativos/RBH130-1.png',
        ],
        imagen: '/assets/productos/hornos-rotativos/RBH130.png',
        ficha: '/productos/ficha/RBH130',
        telefono: '+54 9 11 4088-2236',
      },
    ],
  },
  {
    id: 'carros',
    nombre: 'Carros',
    descripcion: 'Carros para transporte y fermentación de bandejas.',
    productos: [
      {
        id: 'zorra-45x70',
        modelo: 'Zorra 45×70',
        nombre: 'Zorra 45×70 — 15 estantes',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '45 × 70 cm' },
          { icono: '📦', label: 'Estantes', valor: '15 estantes' },
        ],
        imagen: '/assets/productos/carros/Zorra.png',
        ficha: null,
      },
      {
        id: 'zorra-70x90',
        modelo: 'Zorra 70×90',
        nombre: 'Zorra 70×90 — 15 estantes',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '70 × 90 cm' },
          { icono: '📦', label: 'Estantes', valor: '15 estantes' },
        ],
        imagen: '/assets/productos/carros/Zorra.png',
        ficha: null,
      },
    ],
  },
  {
    id: 'bandejas',
    nombre: 'Bandejas',
    descripcion: 'Bandejas bagueteras y enlozadas para todo tipo de producción.',
    productos: [
      {
        id: 'bandeja-baguetera-45x70',
        modelo: 'Baguetera 45×70',
        nombre: 'Bandeja Baguetera 45×70',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '45 × 70 cm' },
          { icono: '〰️', label: 'Ondas', valor: '9 o 10 ondas' },
        ],
        imagen: '/assets/productos/bandejas/BandejaBaguetera.png',
        ficha: null,
      },
      {
        id: 'bandeja-baguetera-40x60',
        modelo: 'Baguetera 40×60',
        nombre: 'Bandeja Baguetera 40×60',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '40 × 60 cm' },
          { icono: '〰️', label: 'Ondas', valor: '8 ondas' },
        ],
        imagen: '/assets/productos/bandejas/BandejaBaguetera.png',
        ficha: null,
      },
      {
        id: 'bandeja-baguetera-70x90',
        modelo: 'Baguetera 70×90',
        nombre: 'Bandeja Baguetera 70×90',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '70 × 90 cm' },
          { icono: '〰️', label: 'Ondas', valor: '12 ondas' },
        ],
        imagen: '/assets/productos/bandejas/BandejaBaguetera.png',
        ficha: null,
      },
      {
        id: 'bandeja-enlozada-2cm',
        modelo: 'Enlozada 45×70×2',
        nombre: 'Bandeja Enlozada 45×70 — 2 cm',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '45 × 70 cm' },
          { icono: '↕️', label: 'Alto', valor: '2 cm' },
        ],
        imagen: '/assets/productos/bandejas/BandejaEnlozada.png',
        ficha: null,
      },
      {
        id: 'bandeja-enlozada-4cm',
        modelo: 'Enlozada 45×70×4',
        nombre: 'Bandeja Enlozada 45×70 — 4 cm',
        descripcion: '',
        specs: [
          { icono: '📐', label: 'Medidas', valor: '45 × 70 cm' },
          { icono: '↕️', label: 'Alto', valor: '4 cm' },
        ],
        imagen: '/assets/productos/bandejas/BandejaEnlozada.png',
        ficha: null,
      },
    ],
  },
];

// Helpers
export const getAllProducts = () => categorias.flatMap(c => c.productos);
export const getProductById = (id) => getAllProducts().find(p => p.id === id);
export const getCategoriaById = (id) => categorias.find(c => c.id === id);
